import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import EmploymentDetailTable from "./EmploymentDetailTable";
import EmploymentDetailsForSingleUserTable from "./EmploymentDetailForSingleUser";
import EmploymentDetailView from "./employment_detail_form/EmploymentDetailView";
import { getApi, getHeaders } from "../../../utils/apiHelper";
import DateTimeService from "../../../utils/dateTimeService";

import {
  main_url,
  getUserId,
  getMainRole,
  getCookieData,
  startSaving,
} from "../../../utils/CommonFunction";
import EmploymentDetailForm from "./employment_detail_form/EmploymentDetailForm";
import moment from "moment";

class EmployeeDetailMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddNew: false,
      loading: false,
      user_info: getCookieData("user_info"),
      user_id: getUserId("user_info"),
      is_main_role: getMainRole(),
      isTable: true,
      isView: false,
      tableView: false,
      isEdit: false,
      tableEdit: false,
      datasource: [],
      permission_status: {},
      selected_region: null,
      selected_branch: null,
      selected_department: null,
      selected_designation: null,
      branchlist: null,
      employeeIdList: null,
      regionList: [],
      departmentlist: null,
      designationList: null,
      exitStatusList: null,
      selected_exit_status: null,
      selected_user_id: null,
      searchValue: "",
      employeeData: null,
      addNew: false,
      employeeName: "",
      employees: [],
      statusList: null,
      selected_status: null,
      employedDate: null,
      effectiveDate: null,
      actualDate: null,
      salary: "",
      disconDate: null,
      resignReason: "",
      transactionType: "",
      transactionTypesList: [],
      demotionReasonsList: [],
      selectedEmploymentData: null,
      selectedEmployeeId: null,
      edit: false,
      view: false,
      level_options: null,
      sub_level_options: null,
      career_level: null,
      career_sub_level: null,
      jobList: null,
      selected_job: null,
      selected_disCon_status: null,
      attachment: null,
      remark: null,
      demotionReason: null,
      monitoringEndDate: null,
      lastWorkingDate: null,
      disConStatusList: [
        { value: 1, label: "True" },
        { value: 0, label: "False" },
      ],
      employmentDataForSingleUser: null,
      salaryList: [],
      singleView: false,
      statusList: [
        { label: "All", value: -1 },
        { label: "Active", value: 0 },
        { label: "Exit", value: 1 },
      ],
      salaryPermission: [],
      exitList: [
        { label: "Active", value: 0 },
        { label: "Exit", value: 1 },
      ],
      hasDoneSubmitOrSave: false,
    };
  }

  async componentDidMount() {
    this.salaryPermission();
    this.getEmployeeList();
    this.getDesignationList();
    this.getBranchList();
    this.getDepartmentList();
    this.getExitStatus();
    this.getEmployeeCodeList();
    this.getTransactionTypesList();
    this.getDemotionReasonsList();
    this.getJobList();
    this.getRegionList();
    this.getSalaryTemplate();
    this.getStatusList();
    this.getEmployees();
    const level = await this.getLevelOptions();
    const sub_level = await this.getCareerSubLevelOptions();
    const level_options =
      level &&
      level.map((v) => ({
        ...v,
        label: v.career_level,
        value: v.career_level,
      }));
    const sub_level_options =
      sub_level &&
      sub_level.map((v) => ({
        ...v,
        label: v.career_sub_level,
        value: v.career_sub_level,
      }));
    this.setState({
      level_options,
      sub_level_options,
    });

    if (this.props.data) {
      this.goToViewForm(this.props.data);
    }
    if (this.props.id) {
      fetch(`${main_url}employee/getDetailUser/${this.props.id}`, {
        headers: getHeaders(),
      })
        .then((res) => {
          if (res.ok) return res.json();
        })
        .then((data) => {
          if (data.length > 0) {
            this.getData(this.props.id);
            this.setState({ tableEdit: true, tableView: false });
          }
        });
    }
  }
  async getSalaryTemplate() {
    const data = await getApi(`${main_url}salaryTemplate/getSalaryTemplate`);
    if (data) {
      this.setState({
        salaryList: data,
      });
    }
  }
  salaryPermission() {
    fetch(`${main_url}dashboard/salaryPermission/${this.state.user_id}`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        if (list.length) {
          this.setState({
            salaryPermission: list,
          });
        }
      });
  }
  getStatusList() {
    fetch(`${main_url}benefit/getStatusList`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          statusList: list,
        });
      });
  }
  getEmployees() {
    fetch(`${main_url}employee/getEmployees`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        const employees = list.map((employee) => {
          return {
            label: `(${employee.employment_id}) ${employee.label}`,
            value: employee.value,
          };
        });

        this.setState({
          employees,
        });
      });
  }

  getExitStatus() {
    fetch(`${main_url}employee/getExitStatus`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          exitStatusList: list.map((v) => ({
            ...v,
            label: v.status,
            value: v.id,
          })),
        });
      });
  }

  getEmployeeCodeList() {
    fetch(`${main_url}employee/getEmployeeCode`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          employeeIdList: list.map((v) => ({
            ...v,
            label: v.employee_code,
            value: v.user_id,
          })),
        });
      });
  }

  getTransactionTypesList() {
    fetch(`${main_url}employee/getTransactionTypes`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          transactionTypesList: list.map((v) => ({
            ...v,
            label: v.transaction_type_name,
            value: v.transaction_type_id,
          })),
        });

        if (this.props.id) {
          const newStaffTransactionType = list.find(
            (v) => v.transaction_type_id === 4
          );
          this.setState({
            transactionType: {
              ...newStaffTransactionType,
              label: newStaffTransactionType.transaction_type_name,
              value: newStaffTransactionType.transaction_type_id,
            },
          });
        }
      });
  }

  getDemotionReasonsList() {
    fetch(`${main_url}employee/getDemotionReasons`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          demotionReasonsList: list.map((v) => ({
            ...v,
            label: v.demotion_reason_name,
            value: v.demotion_reason_id,
          })),
        });
      });
  }

  getJobList() {
    fetch(`${main_url}employee/getJobTitle`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          jobList: list.map((v) => ({ ...v, label: v.job_title, value: v.id })),
        });
      });
  }

  getLevelOptions = async () => {
    var res = await fetch(`${main_url}allowLevel/getLevel`, {
      headers: getHeaders(),
    });
    if (res.ok) return res.json();
    else return [];
  };

  getCareerSubLevelOptions = async () => {
    var res = await fetch(`${main_url}allowLevel/getCareerSubLevel`, {
      headers: getHeaders(),
    });
    if (res.ok) return res.json();
    else return [];
  };

  getEmployeeList(id) {
    fetch(`${main_url}employee/getEmployeeDetail`, {
      headers: getHeaders(),
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        if (res) {
          this.setState({ employeeData: res });
        }
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  getDesignationList() {
    fetch(`${main_url}main/getDesignations`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          designationList: list, //list.map(v => ({ ...v, label: v.region_name, value: v.region_id }))
        });
      });
  }

  getBranchList() {
    fetch(`${main_url}benefit/getBranchList`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ value: 0, label: "All" });
        this.setState({
          branchlist: list.map((v) => ({
            ...v,
          })),
        });
      });
  }
  getRegionList() {
    fetch(`${main_url}benefit/getRegionList`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ state_id: 0, state_name: "All" });
        this.setState({
          regionList: list.map((v) => ({
            ...v,
            label: v.state_name,
            value: v.state_id,
          })),
        });
      });
  }
  getDepartmentList() {
    fetch(`${main_url}benefit/getDepartmentList`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ departments_id: 0, deptname: "All" });
        this.setState({
          departmentlist: list.map((v) => ({
            ...v,
            label: v.deptname,
            value: v.departments_id,
          })),
        });
      });
  }

  getData(id) {
    fetch(`${main_url}employee/getDetailUser/${id}`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((data) => {
        if (data.length > 0) {
          this.setState({
            selectedEmploymentData: data[0],
            edit: false,
            view: false,
            addNew: true,
            date: moment(new Date()).format("YYYY-MM-DD"),
            // selectedEmployeeId:[{label:'23442',user_id:1,value:1}],
            selectedEmployeeId: data.map((v) => ({
              user_id: v.user_id,
              label: v.employment_id,
              value: v.employment_id,
            }))[0],
            employeeName: data[0].employee_name,
            selected_designation: this.state.designationList.find(
              (c) => c.value == data[0].designations_id
            ), //
            selected_branch: this.state.branchlist.find(
              (c) =>
                parseInt(c.value) ===
                (data[0].branch_name
                  ? parseInt(data[0].branch_name)
                  : data[0].branch_name)
            ),
            selected_department: this.state.departmentlist.find(
              (c) => c.departments_id == data[0].departments_id
            ),
            selected_status: this.state.statusList.find(
              (v) => v.value === parseInt(data[0].employee_status)
            ),
            selected_exit_status: this.state.exitStatusList.find(
              (v) =>
                v.id ===
                parseInt(data[0].exit_status == null ? 0 : data[0].exit_status)
            ),
            employedDate: data[0].employ_date,
            effectiveDate: data[0].last_promotion_date,
            actualDate: data[0].last_promotion_date,
            discontinute_date: data[0].discontinued_date
              ? moment(data[0].discontinued_date).format("YYYY-MM-DD")
              : null,
            selected_disCon_status: this.state.disConStatusList.find(
              (v) => v.value === parseInt(data[0].discontinued_status)
            )
              ? this.state.disConStatusList.find(
                  (v) => v.value === parseInt(data[0].discontinued_status)
                )
              : { value: 0, label: "False" },

            salary:
              this.state.salaryPermission.length > 0 &&
              parseInt(data[0].career_level_id) >= 7
                ? data[0].basic_salary
                : this.state.salaryPermission.length === 0 &&
                  parseInt(data[0].career_level_id) >= 7
                ? ""
                : data[0].basic_salary, //Added by AKM 2023-Aug-11
            // if(HasPermission && Above Lv7 ? show salary : Nextcondition (Don'tHasPermission && Above Lv7) ? hide salary : InvalidPreviousconditions show salary under level 7 )
            resignReason: data[0].resign_reason,
            selected_job: this.state.jobList.find(
              (v) => v.value == data[0].job_title
            ),
            career_level: this.state.level_options.find(
              (v) =>
                parseInt(v.career_level_id) ===
                parseInt(data[0].career_level_id)
            ),
            career_sub_level: this.state.sub_level_options.find(
              (v) => v.career_sub_level_id === data[0].career_sub_level_id
            ),
            attachment: data[0].employment_detail_attachment,
          });
        }
        // else {
        //   this.setState({
        //     selectedEmploymentData: null,
        //     edit: false,
        //     addNew: true,
        //     date: moment(new Date()).format("YYYY-MM-DD"),
        //     employeeName: null,
        //     selected_designation: null, //
        //     selected_branch: null,
        //     selected_department: null,
        //     selected_status: null,
        //     selected_exit_status: null,
        //     employedDate: null,
        //     effectiveDate: null,
        //     actualDate: null,
        //     discontinute_date: null,
        //     selected_disCon_status: null,
        //     salary: null,
        //     resignReason: null,
        //     selected_job: null,
        //     career_level: null,
        //     career_sub_level: null,
        //   });
        // }
      });
  }

  showToast = (status, text) => {
    if (status === 200) {
      toast.success(text);
      window.location.reload();
    } else {
      startSaving();
      toast.error(text);
    }
  };

  handleSelectedDeaprtment = (event) => {
    let filterData = this.state.jobList.filter(
      (v) => v.department_id == event.departments_id
    );

    if (event !== null)
      // if(event.departments_id !==0){
      //   this.setState({
      //     jobList:filterData
      //   })
      // }
      this.setState({
        selected_department: event,
      });
  };

  handleSelectedBranch = (event) => {
    if (event !== null)
      this.setState({
        selected_branch: event,
      });
  };
  handleSelectedRegion = (event) => {
    if (event !== null)
      this.setState({
        selected_region: event,
      });
  };

  handleSelectedDesignation = (event) => {
    const { selected_designation, jobList } = this.state;
    const hasDesignationChanged =
      selected_designation?.value != event?.value ||
      selected_designation?.departments_id != event?.departments_id;

    if (!hasDesignationChanged) {
      return;
    }

    const filteredJobList = event
      ? (jobList || []).filter(
          (job) =>
            job.designation_id == event.value &&
            job.department_id == event.departments_id
        )
      : [];

    this.setState({
      selected_designation: event,
      selected_job: filteredJobList.length === 1 ? filteredJobList[0] : null,
    });
  };
  handleSelectedTransactionType = (event) => {
    if (!event || event === this.state.transactionType) return;
    if (!this.state.edit) this.resetFormData();
    this.setState({
      transactionType: event,
    });
  };
  handleSelectedDemotionReason = (event) => {
    this.setState({
      demotionReason: event,
    });
  };

  handleSelectedstatus = (event) => {
    if (event !== null)
      this.setState({
        selected_status: event,
      });
  };
  handleSelectedStatus = (event) => {
    if (event !== null)
      this.setState({
        selected_status: event,
      });
  };
  handleSelectedEmployee = (event) => {
    if (event !== null)
      this.setState({
        selected_user_id: event,
      });
  };

  handleSelectedEmployeeId = (event) => {
    if (event !== null) this.getData(event.user_id);
    this.setState({
      selectedEmployeeId: event,
    });
  };

  handleSelectedExitStatus = (event) => {
    if (event !== null)
      this.setState({
        selected_exit_status: event,
      });
  };

  handleSelectedDisConStatus = (event) => {
    if (event !== null)
      this.setState({
        selected_disCon_status: event,
      });
  };

  handleSelectedJob = (event) => {
    if (event !== null)
      this.setState({
        selected_job: event,
      });
  };

  handleSearchList = (e) => {
    this.setState({
      loading: true,
    });
    e.preventDefault();

    // this.getEmployeeList({ regionId, depId, branchId, designId,statusId });
    fetch(
      `${main_url}employee/getEmployeeDetail/${
        this.state.selected_region ? this.state.selected_region.state_id : 0
      }/${
        this.state.selected_department
          ? this.state.selected_department.departments_id
          : 0
      }/${this.state.selected_branch ? this.state.selected_branch.value : 0}/${
        this.state.selected_designation
          ? this.state.selected_designation.value
          : 0
      }/${this.state.selected_job ? this.state.selected_job.value : 0}/${
        this.state.selected_status ? this.state.selected_status.value : -1
      }/${
        this.state.selected_exit_status
          ? this.state.selected_exit_status.value
          : 0
      }/${
        this.state.selected_user_id ? this.state.selected_user_id.value : -1
      }`,
      {
        headers: getHeaders(),
      }
    )
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        if (res) {
          this.setState({ employeeData: res, loading: false });
        }
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
    // .then(res => { if (res.ok) return res.json() })
    // .then(list => {
    //   this._setTableData(list);
    // })
  };

  handleAddFormInputChange = (e) => {
    if (e.target.name === "employeeName") {
      this.setState({
        employeeName: e.target.value,
      });
    } else if (e.target.name === "salary") {
      this.setState({
        salary: e.target.value,
      });
    } else if (e.target.name === "resignReason") {
      this.setState({
        resignReason: e.target.value,
      });
    } else if (e.target.name === "remark") {
      this.setState({
        remark: e.target.value,
      });
    }
  };

  handleDatePickerChange = (name, value) => {
    switch (name) {
      case "employedDate":
        this.setState({
          employedDate: value,
        });
        break;
      case "effectiveDate":
        this.setState({
          effectiveDate: value,
        });
        break;
      case "actualDate":
        this.setState({
          actualDate: value,
        });
        break;
      case "monitoringEndDate":
        this.setState({
          monitoringEndDate: value,
        });
        break;
      case "lastWorkingDate":
        this.setState({
          lastWorkingDate: value,
        });
        break;
      case "disconDate":
        this.setState({
          disconDate: value,
        });
        break;
      default:
        return;
    }
  };

  handleChangeFile = (e) => {
    var files = document.getElementById("attach_file").files;
    if (files.length === 0) return;
    this.setState({
      attachment: files[0],
    });
  };

  removeOldDocument(event) {
    this.setState({
      attachment: null,
    });
  }

  submitAddForm = (e) => {
    e.preventDefault();
    const {
      selected_status,
      effectiveDate,
      actualDate,
      salary,
      selected_job,
      transactionType,
      selected_disCon_status,
      disconDate,
      resignReason,
      employedDate,
      career_sub_level,
      selected_exit_status,
      selected_branch,
      career_level,
      selected_department,
      selected_designation,
      employeeName,
      selectedEmployeeId,
      user_id,
      departmentlist,
      attachment,
      remark,
      demotionReason,
      monitoringEndDate,
      lastWorkingDate,
    } = this.state;

    if (!selectedEmployeeId) {
      return toast.error("Please select the Employee Code!");
    }
    if (!transactionType) {
      return toast.error("Please select the Transaction Type!");
    }
    // required_job_role
    // if (!selected_job) {
    //   return toast.error("Please select the Job Role!");
    // }

    if (selected_branch != null && selected_branch.value == 0) {
      toast.error("Please complete all required fields.");
    } else {
      //Modify by STHA -- Get Department id from selected designation
      let selected_department_data =
        selected_designation != null &&
        departmentlist.filter(
          (v) => v.departments_id == selected_designation.departments_id
        )[0];

      let data = {
        user_id: selectedEmployeeId.user_id,
        employed_status: selected_status ? selected_status.value : null,
        employee_name: employeeName ? employeeName : "",
        employee_code: selectedEmployeeId
          ? selectedEmployeeId.label.trim()
          : null,
        designation: selected_designation ? selected_designation.value : null,
        branch: selected_branch ? parseInt(selected_branch.value) : null,
        // department: selected_department
        //   ? selected_department.departments_id
        //   : null,
        //Modify_BY_STHA_to_get_deparment_id
        department: selected_department_data
          ? selected_department_data.departments_id
          : null,
        career_level: career_level ? career_level.career_level_id : null,
        career_sub_level: career_sub_level
          ? career_sub_level.career_sub_level_id
          : null,
        exit_status: selected_exit_status ? selected_exit_status.value : null,
        employee_date: new DateTimeService(employedDate).formatDate,
        effective_date: new DateTimeService(effectiveDate).formatDate,
        salary: salary ? salary : "",
        job_title: selected_job ? selected_job.id : null,
        transactionType: transactionType.transaction_type_id,
        discontinute_status: selected_disCon_status
          ? selected_disCon_status.value
          : null,
        discontinute_date: new DateTimeService(disconDate).formatDate,
        resign_reason: resignReason ? resignReason : "",
        date: new DateTimeService(actualDate).formatDate,
        attachment: attachment,
        remark: remark ? remark : "",
        demotion_reason: demotionReason?.demotion_reason_id,
        monitoring_end_date: new DateTimeService(monitoringEndDate).formatDate,
        last_working_date: new DateTimeService(lastWorkingDate).formatDate,
      };
      let status = 0;

      const formdata = new FormData();
      const attachFileElememt = document.querySelector("#attach_file");
      if (attachFileElememt) {
        const imageFiles = document.querySelector("#attach_file").files;
        if (imageFiles.length > 0) {
          var imagedata = document.querySelector("#attach_file").files[0];
          formdata.append("uploadfile", imagedata);
        }
      }
      formdata.append("employee_info", JSON.stringify(data));

      fetch(`${main_url}employee/addEmploymentDetail`, {
        method: "POST",
        headers: getHeaders(),
        body: formdata,
      })
        .then((res) => {
          status = res.status;
          return res.text();
        })
        .then((text) => {
          if (status === 200) {
            toast.success(text);
            this.setState({
              hasDoneSubmitOrSave: true,
            });
          } else toast.error(text);
        });
    }
  };

  goToEditForm = (data) => {
    this.setState({
      selectedEmploymentData: data,
      edit: true,
      addNew: false,
      view: false,

      user_id: data.user_id,
      // selectedEmployeeId: this.state.employeeIdList.filter(
      //   (v) => v.value == data.user_id
      // ).length > 0 ? this.state.employeeIdList.filter(
      //   (v) => v.value == data.user_id
      // )[0] : null,
      selectedEmployeeId: data.emp_id,
      employeeName: data.fullname,
      selected_designation: this.state.designationList.find(
        (c) => c.label == data.designation_name
      ), //
      selected_branch: this.state.branchlist.find(
        (v) => v.label == data.branch_name
      ),
      selected_department: this.state.departmentlist.find(
        (v) => v.label == data.deptname
      ),
      selected_status: this.state.statusList.find(
        (v) => v.value == parseInt(data.status)
      ),
      selected_exit_status: this.state.exitStatusList.find(
        (v) => v.id == parseInt(data.exit_status)
      ),
      employedDate: data.employee_date,
      effectiveDate: data.effective_date,
      actualDate: data.actual_date,
      disconDate: data.discontinute_date != null ? data.discontinute_date : "",
      selected_disCon_status: this.state.disConStatusList.find(
        (v) => v.value == parseInt(data.discontinute_status)
      )
        ? this.state.disConStatusList.find(
            (v) => v.value == parseInt(data.discontinute_status)
          )
        : { value: 0, label: "False" },
      // selected_disCon_status:{value:234,label:'san ml'},
      salary: data.salary,
      transactionType: this.state.transactionTypesList.find(
        (v) => v.value === data.transaction_type
      ),
      resignReason: data.resign_reason,
      selected_job: this.state.jobList.find(
        (c) => parseInt(c.id) == data.job_title
      ),
      career_level: this.state.level_options.find(
        (v) => v.career_level_id == data.career_level
      ),
      career_sub_level: this.state.sub_level_options.find(
        (v) => v.career_sub_level_id == data.career_sub_level
      ),
      attachment: data.attachment,
      remark: data.remark,
      demotionReason: this.state.demotionReasonsList.find(
        (v) => v.value === data.demotion_reason
      ),
      monitoringEndDate: data.monitoring_end_date,
      lastWorkingDate: data.last_working_date,
    });
  };

  goToViewForm = (data) => {
    this.setState({
      tableView: true,
    });
    fetch(`${main_url}employee/getEmployUserDetail/${data.user_id}`, {
      headers: getHeaders(),
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        if (res) {
          this.setState({ employmentDataForSingleUser: res });
        }
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  };

  goToSingleViewForm = (data) => {
    this.setState({
      selectedEmploymentData: data,
      edit: false,
      view: false,
      addNew: false,
      singleView: true,

      user_id: data.user_id,
      selectedEmployeeId: this.state.employeeIdList.find(
        (v) => v.value == data.user_id
      ),
      employeeName: data.fullname,
      selected_designation: this.state.designationList.find(
        (c) => c.label == data.designation_name
      ), //
      selected_branch: this.state.branchlist.filter(
        (v) => v.label == data.branch_name
      ),
      selected_department: this.state.departmentlist.find(
        (v) => v.label == data.deptname
      ),
      selected_status: this.state.statusList.find(
        (v) => v.value == parseInt(data.status)
      ),
      selected_exit_status: this.state.exitStatusList.find(
        (v) => v.id == parseInt(data.exit_status)
      ),
      employedDate: data.employee_date,
      effectiveDate: data.effective_date,
      actualDate: data.actual_date,
      disconDate: data.discontinute_date != null ? data.discontinute_date : "",
      selected_disCon_status: this.state.disConStatusList.find(
        (v) => v.value == parseInt(data.discontinute_status)
      )
        ? this.state.disConStatusList.find(
            (v) => v.value == parseInt(data.discontinute_status)
          )
        : [{ value: 0, label: "False" }],
      salary: data.salary,
      transactionType: this.state.transactionTypesList.find(
        (v) => v.value === data.transaction_type
      ),
      resignReason: data.resign_reason,
      selected_job: this.state.jobList.find(
        (c) => parseInt(c.id) == data.job_title
      ),
      career_level: this.state.level_options.find(
        (v) => v.career_level_id == data.career_level
      ),
      career_sub_level: this.state.sub_level_options.find(
        (v) => v.career_sub_level_id == data.career_sub_level
      ),
      attachment: data.attachment,
      remark: data.remark,
      demotionReason: this.state.demotionReasonsList.find(
        (v) => v.value === data.demotion_reason
      ),
      monitoringEndDate: data.monitoring_end_date,
      lastWorkingDate: data.last_working_date,
    });
  };

  handleUpdateData = (e) => {
    e.preventDefault();
    const {
      selected_status,
      effectiveDate,
      selectedEmploymentData,
      actualDate,
      salary,
      selected_job,
      transactionType,
      selected_disCon_status,
      disconDate,
      resignReason,
      employedDate,
      career_sub_level,
      selected_exit_status,
      selected_branch,
      career_level,
      selected_department,
      selected_designation,
      employeeName,
      selectedEmployeeId,
      user_id,
      departmentlist,
      attachment,
      remark,
      demotionReason,
      monitoringEndDate,
      lastWorkingDate,
    } = this.state;
    //Modify by LMM -- Get Department id from selected designation (STHA Logic)
    let selected_department_data =
      selected_designation != null &&
      departmentlist.filter(
        (v) => v.departments_id === selected_designation.departments_id
      )[0];

    if (!transactionType) {
      return toast.error("Please select the Transaction Type!");
    }
    // required_job_role
    // if (!selected_job) {
    //   return toast.error("Please select the Job Role!");
    // }

    let data = {
      user_id: user_id,
      employed_status: selected_status ? selected_status.value : null,
      employee_name: employeeName ? employeeName.toUpperCase : "",
      employee_code: selectedEmployeeId.trim(),
      // ? selectedEmployeeId.label.trim()
      // : null,
      designation: selected_designation ? selected_designation.value : null,
      branch: selected_branch ? parseInt(selected_branch.value) : null,
      //Modify_BY_LMM_to_get_deparment_id (STHA Logic)
      deparment: selected_department_data
        ? selected_department_data.departments_id
        : null,
      career_level: career_level ? career_level.career_level_id : null,
      career_sub_level: career_sub_level
        ? career_sub_level.career_sub_level_id
        : null,
      exit_status: selected_exit_status ? selected_exit_status.value : null,
      employee_date: new DateTimeService(employedDate).formatDate,
      effective_date: new DateTimeService(effectiveDate).formatDate,
      date: new DateTimeService(actualDate).formatDate,
      salary: salary ? salary : "",
      job_title: selected_job ? selected_job.id : null,
      transactionType: transactionType.transaction_type_id,

      discontinute_status: selected_disCon_status
        ? selected_disCon_status.value
        : null,
      discontinute_date: new DateTimeService(disconDate).formatDate,
      resign_reason: resignReason ? resignReason : "",
      attachment: attachment,
      remark: remark ? remark : "",
      demotion_reason: demotionReason?.demotion_reason_id,
      monitoring_end_date: new DateTimeService(monitoringEndDate).formatDate,
      last_working_date: new DateTimeService(lastWorkingDate).formatDate,
    };
    // if(typeof(selected_disCon_status)=='array'){
    //   data.discontinute_status =selected_disCon_status.length > 0 ? selected_disCon_status.value : null
    // }else{
    //   data.discontinute_status=selected_disCon_status
    //   ? selected_disCon_status.value
    //   : null,
    // }
    let status = 0;

    const formdata = new FormData();
    const attachFileElement = document.querySelector("#attach_file");
    if (attachFileElement) {
      const imageFiles = document.querySelector("#attach_file").files;
      if (imageFiles.length > 0) {
        var imagedata = document.querySelector("#attach_file").files[0];
        formdata.append("uploadfile", imagedata);
      }
    }
    formdata.append("employee_info", JSON.stringify(data));

    fetch(
      `${main_url}employee/updateEmploymentDetail/${
        selectedEmploymentData.id == undefined
          ? this.props.id
          : selectedEmploymentData.id
      }`,
      {
        method: "POST",
        headers: getHeaders(),
        body: formdata,
      }
    )
      .then((res) => {
        status = res.status;
        return res.text();
      })
      .then((text) => {
        if (status === 200) {
          toast.success(text);
          this.setState({
            hasDoneSubmitOrSave: true,
          });
        } else toast.error(text);
      });
  };

  goBackToEmploymentDetails = (e) => {
    e.preventDefault();
    window.location.replace("/employment_details");
  };

  handleFormCancel = () => {
    this.setState({
      addNew: false,
      tableEdit: false,
      tableView: false,
    });
    this.getEmployeeList();
    this.clearFormData();
  };

  handleLevelSelectorChange = (val, key) => {
    if (!val) return;

    const { sub_level_options, level_options, career_level, salaryList } = this.state;
    const value =
      key === "career_level"
        ? level_options.find(
            (v) => Number(v.career_level_id) === Number(val.career_level_id)
          )
        : sub_level_options.find(
            (v) =>
              Number(v.career_sub_level_id) === Number(val.career_sub_level_id)
          );
    if (!value) return;

    const nextState = { [key]: value };
    let selectedSubLevel = value;
    if (key === "career_level") {
      if (Number(value.career_level_id) === Number(career_level?.career_level_id)) {
        this.setState(nextState);
        return;
      }
      selectedSubLevel = (sub_level_options || []).find(
        (v) => Number(v.career_level_id) === Number(value.career_level_id)
      );
      nextState.career_sub_level = selectedSubLevel || null;
    }

    const salaryInfo = selectedSubLevel
      ? salaryList.find(
          (v) => v.career_sub_level == selectedSubLevel.career_sub_level_id
        )
      : null;
    nextState.salary = salaryInfo ? salaryInfo.basic_salary : 0;
    this.setState(nextState);
  };

  resetFormData = () => {
    const attachFile = document.getElementById("attach_file");
    if (attachFile) {
      document.getElementById("attach_file").value = "";
    }
    this.setState({
      selectedEmployeeId: "",
      employeeName: "",
      selected_status: null,
      selected_designation: null,
      selected_branch: null,
      career_level: null,
      career_sub_level: null,
      remark: null,
      attachment: null,
      employedDate: null,
      effectiveDate: null,
      actualDate: null,
      selected_job: null,
      demotionReason: null,
      monitoringEndDate: null,
      lastWorkingDate: null,
      selected_disCon_status: null,
      disconDate: null,
      selected_exit_status: null,
      resignReason: "",
    });
  };

  clearFormData = () => {
    this.resetFormData();
    this.setState({
      transactionType: "",
      selected_region: null,
      selected_department: null,
      addNew: false,
      salary: "",
      selectedEmploymentData: null,
      edit: false,
      view: false,
    });
  };
  BackToTable = () => {
    this.setState({
      viewForm: false,
      editForm: false,
      selectedEmployeeData: null,
      editForm: false,
    });
    const regionId = this.state.selected_region
      ? this.state.selected_region.region_id
      : 0;
    const depId = this.state.selected_department
      ? this.state.selected_department.departments_id
      : 0;
    const branchId = this.state.selected_branch
      ? this.state.selected_branch.branch_id
      : 0;
    const designId = this.state.selected_designation
      ? this.state.selected_designation.value
      : 0;
    const statusId = this.state.selected_status
      ? this.state.selected_status.value
      : 0;
    this.getEmployeeList({ regionId, depId, branchId, designId, statusId });
  };
  render() {
    const {
      user_id,
      addNew,
      level_options,
      sub_level_options,
      employeeName,
      jobList,
      selected_job,
      statusList,
      exitStatusList,
      selected_exit_status,
      selected_user_id,
      selected_status,
      employeeIdList,
      employedDate,
      disconDate,
      resignReason,
      transactionTypesList,
      transactionType,
      selectedEmployeeId,
      effectiveDate,
      actualDate,
      salary,
      designationList,
      selected_designation,
      employmentDataForSingleUser,
      branchlist,
      selected_branch,
      disConStatusList,
      selected_disCon_status,
      departmentlist,
      regionList,
      selected_department,
      edit,
      view,
      singleView,
      career_level,
      career_sub_level,
      tableEdit,
      tableView,
      salaryList,
      salaryPermission,
      attachment,
      remark,
      demotionReasonsList,
      demotionReason,
      monitoringEndDate,
      lastWorkingDate,
      hasDoneSubmitOrSave,
    } = this.state;
    if (this.state.loading == true) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <h2>Loading...</h2>
        </div>
      );
    } else {
      return (
        <div className=" border-bottom white-bg dashboard-header">
          <ToastContainer position={toast.POSITION.TOP_RIGHT} />
          {/* <form > */}
          <div className="row wrapper white-bg page-heading">
            <div className="col-lg-12 col-md-12">
              <ol className="breadcrumb">
                <li style={{ fontSize: 18 }}>Employee</li>
                <li className="active" style={{ fontSize: 18 }}>
                  <a href="#"> Employment Details</a>
                </li>
              </ol>
            </div>
            {addNew ||
            edit ||
            singleView ||
            view ||
            this.state.tableView ? null : (
              <div
                className=""
                style={{
                  marginTop: 50,
                  //   alignItems: "start",
                  //   display: "flex",
                  //   flexWrap: "wrap",
                }}
              >
                <div
                  className="col-lg-2 col-md-3 col-sm-12"
                  style={{
                    marginBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>Region</div>

                  <Select
                    options={this.state.regionList}
                    value={this.state.selected_region}
                    onChange={this.handleSelectedRegion.bind(this)}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
                <div
                  className="col-lg-2 col-md-3 col-sm-12"
                  style={{
                    marginBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>Department</div>

                  <Select
                    options={this.state.departmentlist}
                    value={this.state.selected_department}
                    onChange={this.handleSelectedDeaprtment.bind(this)}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
                <div
                  className="col-lg-2 col-md-3 col-sm-12"
                  style={{
                    marginBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>Branch</div>

                  <Select
                    options={this.state.branchlist}
                    value={this.state.selected_branch}
                    onChange={this.handleSelectedBranch.bind(this)}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
                <div
                  className="col-lg-2 col-md-3 col-sm-12"
                  style={{
                    marginBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>Designation</div>

                  <Select
                    options={this.state.designationList}
                    value={this.state.selected_designation}
                    onChange={this.handleSelectedDesignation.bind(this)}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
                <div
                  className="col-lg-2 col-md-3 col-sm-12"
                  style={{
                    marginBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>Job Title</div>
                  <Select
                    options={
                      this.state.selected_department != null
                        ? this.state.selected_department.department_id == 0
                          ? this.state.jobList
                          : this.state.jobList.filter(
                              (v) =>
                                v.department_id ==
                                this.state.selected_department.departments_id
                            )
                        : this.state.jobList
                    }
                    value={this.state.selected_job}
                    onChange={this.handleSelectedJob.bind(this)}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
                <div
                  className="col-lg-2 col-md-3 col-sm-12"
                  style={{
                    marginBottom: 10,
                    paddingLeft: 20,
                    paddingRight: 20,
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>Exit Status</div>

                  <Select
                    options={this.state.exitList}
                    value={this.state.selected_exit_status}
                    onChange={this.handleSelectedExitStatus.bind(this)}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
                <div
                  className="col-lg-2 col-md-3 col-sm-12"
                  style={{
                    marginBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>Status</div>
                  <Select
                    options={this.state.statusList}
                    value={this.state.selected_status}
                    onChange={this.handleSelectedstatus.bind(this)}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
                <div
                  className="col-lg-3 col-md-4 col-sm-18"
                  style={{
                    marginBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>Employee Name</div>
                  <Select
                    options={this.state.employees}
                    value={this.state.selected_user_id}
                    onChange={this.handleSelectedEmployee.bind(this)}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
                {/* <div className="col-lg-2 col-md-5" style={{marginTop:"10px"}}>
                <button
                  onClick={() => this.setState({ addNew: true })}
                  style={{
                    borderRadius: 5,
                    padding: 10,
                    background: "#337ab7",
                    color: "white",
                    border: "none",
                  }}
                >
                   Add New 
                </button>
              </div> */}
                <div
                  className="col-lg-2 col-md-3 col-sm-8"
                  style={{ display: "flex", marginTop: 30 }}
                >
                  <button
                    onClick={this.handleSearchList}
                    className="btn btn-primary"
                    style={{ borderRadius: 3, width: 80, marginRight: 15 }}
                  >
                    Search
                  </button>
                  <button
                    onClick={() => this.setState({ addNew: true })}
                    className="btn btn-primary"
                    style={{ borderRadius: 3, width: 80, textAlign: "center" }}
                  >
                    Add New
                  </button>
                </div>
              </div>
            )}
          </div>
          {this.state.tableView ? (
            <div>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <button
                  onClick={() => {
                    this.setState({ tableView: false });
                    this.getEmployeeList();
                    window.location.replace("/employee_list");
                  }}
                  style={{
                    borderRadius: 5,
                    padding: 10,
                    background: "#337ab7",
                    color: "white",
                    border: "none",
                  }}
                >
                  {"Back To List"}
                </button>
              </div>
              <EmploymentDetailsForSingleUserTable
                goToViewForm={null}
                goToEditForm={null}
                salaryList={salaryList}
                salaryPermission={salaryPermission}
                data={
                  this.state.employmentDataForSingleUser
                    ? this.state.employmentDataForSingleUser
                    : []
                }
                permission={{
                  isEdit: 0,
                  isView: 0,
                }}
              />
            </div>
          ) : this.state.singleView ? (
            <>
              <EmploymentDetailView
                user_id={user_id}
                selectedEmployeeId={selectedEmployeeId}
                selected_exit_status={selected_exit_status}
                selected_disCon_status={selected_disCon_status}
                selected_job={selected_job}
                salaryList={salaryList}
                career_level={career_level}
                career_sub_level={career_sub_level}
                transactionType={transactionType}
                employeeName={employeeName}
                handleFormCancel={this.handleFormCancel}
                resignReason={resignReason}
                disconDate={disconDate}
                effectiveDate={effectiveDate}
                salary={salary}
                selected_branch={selected_branch}
                departmentlist={departmentlist}
                selected_designation={selected_designation}
                actualDate={actualDate}
                selected_status={selected_status}
                employedDate={employedDate}
                salaryPermission={this.state.salaryPermission}
                attachment={attachment}
                remark={remark}
                demotionReason={demotionReason}
                monitoringEndDate={monitoringEndDate}
                lastWorkingDate={lastWorkingDate}
              />
            </>
          ) : (
            <>
              {addNew || edit || tableEdit ? (
                <EmploymentDetailForm
                  disableTransactionTypeField={!!this.props.id}
                  main_url={main_url}
                  user_id={user_id}
                  edit={edit}
                  salaryList={salaryList}
                  selectedEmployeeId={selectedEmployeeId}
                  level_options={level_options}
                  sub_level_options={sub_level_options}
                  employeeName={employeeName}
                  statusList={statusList}
                  selected_status={selected_status}
                  handleAddFormInputChange={this.handleAddFormInputChange}
                  handleDatePickerChange={this.handleDatePickerChange}
                  handleSelectedStatus={this.handleSelectedStatus}
                  employedDate={employedDate}
                  effectiveDate={effectiveDate}
                  actualDate={actualDate}
                  salary={salary}
                  disconDate={disconDate}
                  designationList={designationList}
                  selected_designation={selected_designation}
                  branchlist={branchlist}
                  selected_branch={selected_branch}
                  departmentlist={departmentlist}
                  selected_department={selected_department}
                  handleSelectedBranch={this.handleSelectedBranch}
                  handleSelectedDeaprtment={this.handleSelectedDeaprtment}
                  handleSelectedDesignation={this.handleSelectedDesignation}
                  submitAddForm={this.submitAddForm}
                  handleFormCancel={this.handleFormCancel}
                  handleUpdateData={this.handleUpdateData}
                  handleGoBack={this.goBackToEmploymentDetails}
                  handleSelectedEmployeeId={this.handleSelectedEmployeeId}
                  handleLevelSelectorChange={this.handleLevelSelectorChange}
                  career_level={career_level}
                  career_sub_level={career_sub_level}
                  transactionTypesList={transactionTypesList}
                  transactionType={transactionType}
                  handleSelectedTransactionType={
                    this.handleSelectedTransactionType
                  }
                  employeeIdList={employeeIdList}
                  exitStatusList={exitStatusList}
                  selected_exit_status={selected_exit_status}
                  handleSelectedExitStatus={this.handleSelectedExitStatus}
                  jobList={jobList}
                  selected_job={selected_job}
                  handleSelectedJob={this.handleSelectedJob}
                  disConStatusList={disConStatusList}
                  resignReason={resignReason}
                  selected_disCon_status={selected_disCon_status}
                  handleSelectedDisConStatus={this.handleSelectedDisConStatus}
                  salaryPermission={this.state.salaryPermission}
                  handleChangeFile={this.handleChangeFile}
                  attachment={attachment}
                  removeOldDocument={this.removeOldDocument.bind(this)}
                  remark={remark}
                  demotionReasonsList={demotionReasonsList}
                  demotionReason={demotionReason}
                  handleSelectedDemotionReason={
                    this.handleSelectedDemotionReason
                  }
                  monitoringEndDate={monitoringEndDate}
                  lastWorkingDate={lastWorkingDate}
                  hasDoneSubmitOrSave={hasDoneSubmitOrSave}
                />
              ) : (
                <EmploymentDetailTable
                  goToEditForm={this.goToEditForm}
                  exitStatusList={this.state.exitStatusList}
                  career_sub_level={career_sub_level}
                  goToSingleViewForm={this.goToSingleViewForm}
                  data={this.state.employeeData ? this.state.employeeData : []}
                  transactionTypesList={transactionTypesList}
                  demotionReasonsList={demotionReasonsList}
                  jobList={jobList}
                  salaryList={salaryList}
                  salaryPermission={this.state.salaryPermission}
                  statusList={statusList}
                  permission={{
                    isEdit: 1,
                    isView: 1,
                  }}
                  regionList={regionList}
                />
              )}
            </>
          )}
        </div>
      );
    }
  }
}

export default EmployeeDetailMain;
